module.exports = __webpack_public_path__ + "static/media/2-4-3_Spot_UV_Special_01.03d6e431.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_01.jpg
// module id = 1728
// module chunks = 0